import StackAPI from '@/lib/StackAPI'
import Storage from '@/lib/Storage'
import { captureException } from '@sentry/react'
import { PartnerDataProps } from '../types/Partner'

export type GetPartnerResult = PartnerDataProps | { error: string }

const PARTNER_ENDPOINTS: { [key: string]: string } = {
  PUBLISHER: '/partners/publishers',
  VENDOR: '/partners/vendors',
  AFFILIATE: '/partners/affiliates'
}

const getPartner = async (): Promise<GetPartnerResult> => {
  const role = Storage().getActiveRole()

  if (!role) return { error: 'no active role' }

  const { get } = StackAPI()
  const { id, type } = role

  return get<PartnerDataProps>({ path: `${PARTNER_ENDPOINTS[type]}/${id}` })
    .then(({ data, status }) => {
      if (status !== 200) {
        return { error: 'bad response' }
      }

      return data
    })
    .catch((error) => {
      captureException(error, { extra: { role } })
      return { error: 'unknown error' }
    })
}

export default getPartner
